import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Sender, Button} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$ce(2, 'div', [
            _$cc(Button, {
                'size': 'small',
                'disabled': this.get('focused'),
                'ev-click': this.handleFocus,
                'children': 'focus'
            }),
            _$cc(Button, {
                'size': 'small',
                'disabled': !this.get('focused'),
                'ev-click': this.handleBlur,
                'children': 'blur'
            }),
            _$cc(Button, {
                'type': 'primary',
                'size': 'small',
                'disabled': this.isSubmitDisabled(),
                'ev-click': this.handleSubmit,
                'children': 'submit'
            }),
            _$cc(Button, {
                'size': 'small',
                'disabled': this.isClearDisabled(),
                'ev-click': this.handleClear,
                'children': 'clear'
            }),
            _$cc(Button, {
                'size': 'small',
                'disabled': !this.get('generating'),
                'ev-click': this.handleStopGenerate,
                'children': 'stopGenerate'
            })
        ], 4, 'sender-demo-methods-actions'),
        _$cc(Sender, {
            'ref': (i) => this.senderRef = i,
            'generating': this.get('generating'),
            'ev-focus': this.onFocus,
            'ev-blur': this.onBlur,
            'ev-messageSend': this.onMessageSend,
            'ev-stopGenerate': this.onStopGenerate,
            'ev-$model:value': function($v) {
                $this.set('value', $v);
            },
            'value': $this.get('value'),
            'ev-$model:attachments': function($v) {
                $this.set('attachments', $v);
            },
            'attachments': $this.get('attachments')
        }, null, (i) => this.senderRef = i)
    ], 4, 'sender-demo-methods');
};